import { VisitaEstado } from './visitasStatus';

// SMP-551: BackOffice descarga en visitas En revisión (REALIZADA) o Presentadas; el Supervisor, solo en Presentadas.
export const ESTADOS_CON_DESCARGA_INFORMACION_ADICIONAL = [
    VisitaEstado.REALIZADA,
    VisitaEstado.PRESENTADO
];

export const ESTADOS_CON_DESCARGA_INFORMACION_ADICIONAL_SUPERVISOR = [VisitaEstado.PRESENTADO];

/**
 * "Descargar información adicional" (SMP-551): la visita tiene archivos en "Documentación adicional" y está en
 * un estado con la descarga para el perfil. `habilitado` es lo propio de cada grilla: en Visitas, los perfiles con
 * la descarga dentro de las pestañas con descargas; en Visitas ROAM, los roles que descargan en esa grilla.
 */
export const puedeDescargarInformacionAdicional = (
    visita: any,
    habilitado: boolean,
    esSupervisor = false
): boolean =>
    habilitado &&
    (esSupervisor
        ? ESTADOS_CON_DESCARGA_INFORMACION_ADICIONAL_SUPERVISOR
        : ESTADOS_CON_DESCARGA_INFORMACION_ADICIONAL
    ).includes(visita?.estado) &&
    Boolean(visita?.tieneDocumentacionAdicional);
